import { lazy } from 'react';

export const PlayerReportComplaintsRequestForm = lazy(
  () => import('./PlayerReportComplaintsRequestForm'),
);
